export default __webpack_public_path__ + "static/media/in-house-testing-icon.a4c07276.svg";